import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import type { NoDataRenderProps } from './no-data-render.types.ts';
import styles from './no-data-render.module.scss';

export function NoDataRender({ className, message, size = '2x' }: NoDataRenderProps) {
  return (
    <div className={`${className} ${styles.render}`}>
      <FontAwesomeIcon icon={faWarning} size={size} />
      <span>{message}</span>
    </div>
  );
}
